





























































































import { useResult } from '@vue/apollo-composable/dist';
import { defineComponent, SetupContext } from '@nuxtjs/composition-api';
import { usePickupCorporationsQuery } from '@/graphql/graphqlOperations';
import useAppRoute from '~/compositions/useAppRoute';
export default defineComponent({
  setup(_, _context: SetupContext) {
    const { URLs } = useAppRoute();
    const signInUrl = URLs.show_sign_in;
    const { result: pickupCorporationsResult } = usePickupCorporationsQuery();
    const Corporations = useResult(pickupCorporationsResult, []);

    return {
      URLs,
      signInUrl,
      pickupCorporationsResult,
      Corporations,
    };
  },
});
